import React from 'react';


function NameCard() {

    return (
        <div class="Ingredients">
            <table>
            <tr>
                <td>
                <i class="fas fa-phone"></i> +82-51-200-8513
                </td>
            </tr>
            <tr>
                <td>
                <i class="fas fa-envelope"></i> drparklaw [at] gmail.com
                </td>
            </tr>
            <tr>
                <td>
                <i class="fas fa-location-arrow"></i> #604, Law School Bldg, 225 Gudeok-ro, Seo-gu, Busan
                </td>
            </tr>
            </table>
        </div>
    );
}

export default NameCard;